export var zIndexes = {
    background: 1,
    foreground: 2,
    ribbon: 3,
    sticky_item: 4,
    header_menu: 6,
    region_selector: 9,
    chatbot: 11,
    modal: 20,
    drawer: 10000,
    priority_modal: 15000
};
export default zIndexes;
